/**
 * @module app.portal.updateSectorCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function UpdateSectorCtrl($scope, $uibModalInstance, sector, rds) {
        let self = {};
        self.sector = sector[0];
        self.rds = rds;

        self.send = function() {
            $uibModalInstance.close({
                sector: self.sector
            });
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    UpdateSectorCtrl.$inject = ['$scope', '$uibModalInstance', 'sector', 'rds'];

    angular
        .module('app.portal.updateSectorCtrl', ['ui.bootstrap.modal'])
        .controller('UpdateSectorCtrl', UpdateSectorCtrl);
});
